import { createFileRoute } from "@tanstack/react-router";
import { ContactForm } from "@/components/contact-form";

export const Route = createFileRoute("/contacto/formulario")({
  validateSearch: (search: Record<string, unknown>): { interes?: string } =>
    typeof search.interes === "string" ? { interes: search.interes } : {},

  head: () => ({

    meta: [
      { title: "Formulario de contacto | Mine Class" },
      {
        name: "description",
        content: "Completa el formulario y un especialista B2B te contactará en menos de 24 horas.",
      },
      { property: "og:title", content: "Formulario de contacto | Mine Class" },
      {
        property: "og:description",
        content: "Completa el formulario y un especialista B2B de Mine Class te contactará en menos de 24 horas.",
      },
      { property: "og:url", content: "https://mine-class.com/contacto/formulario" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mine-class.com/contacto/formulario" }],
  }),
  component: FormularioPage,
});

function FormularioPage() {
  const { interes } = Route.useSearch();
  return (
    <section
      aria-labelledby="contact-form-heading"
      className="not-prose bg-white border border-[var(--color-outline-variant)] p-6 sm:p-10"
    >
      <h2 id="contact-form-heading" className="sr-only">Formulario de contacto B2B</h2>
      <ContactForm defaultInterest={interes ?? ""} />
    </section>
  );
}

